var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayPalAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 47,
    viewBox: "0 0 67 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 46,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1438 36.5706L30.6115 33.5195L29.5697 33.4945H24.5952L28.0523 10.979C28.0631 10.9108 28.0979 10.8475 28.1488 10.8025C28.1999 10.7575 28.265 10.7328 28.3331 10.7328H36.7209C39.5058 10.7328 41.4275 11.3279 42.4306 12.5026C42.901 13.0537 43.2006 13.6298 43.3456 14.2635C43.4977 14.9285 43.5002 15.723 43.3519 16.6922L43.3411 16.7627V17.3838L43.8115 17.6575C44.2075 17.8734 44.5224 18.1204 44.7638 18.4031C45.1661 18.8745 45.4264 19.4734 45.5363 20.1833C45.65 20.9134 45.6125 21.7825 45.4264 22.7664C45.2117 23.8979 44.8648 24.8835 44.3961 25.6899C43.9653 26.4329 43.4163 27.0493 42.7643 27.5268C42.1418 27.9807 41.4024 28.3252 40.5663 28.5457C39.756 28.7623 38.8322 28.8717 37.819 28.8717H37.1663C36.6996 28.8717 36.2463 29.0443 35.8903 29.3538C35.5334 29.6697 35.2975 30.1015 35.2251 30.5736L35.1757 30.8484L34.3494 36.2263L34.3121 36.4236C34.3021 36.4862 34.285 36.5173 34.26 36.5384C34.2377 36.5577 34.2056 36.5706 34.1743 36.5706H30.1438Z",
    fill: "#28356A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2579 16.8342C44.2331 16.9986 44.2043 17.1666 44.1722 17.3392C43.0661 23.1728 39.2816 25.1881 34.4483 25.1881H31.9874C31.3962 25.1881 30.898 25.6288 30.8061 26.2278L29.1893 36.7622C29.1294 37.1555 29.4245 37.5098 29.8107 37.5098H34.1756C34.6923 37.5098 35.1314 37.1242 35.2128 36.6006L35.2556 36.3729L36.0775 31.016L36.1303 30.7222C36.2107 30.1969 36.6508 29.8109 37.1675 29.8109H37.8203C42.0491 29.8109 45.3597 28.0475 46.3273 22.9441C46.7314 20.8123 46.5222 19.0321 45.4527 17.7802C45.129 17.4028 44.7275 17.0894 44.2579 16.8342Z",
    fill: "#298FC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1002 16.3606C42.9311 16.3099 42.7568 16.2641 42.578 16.2227C42.3981 16.1823 42.214 16.1466 42.0244 16.1152C41.3609 16.005 40.6337 15.9528 39.855 15.9528H33.2807C33.1186 15.9528 32.9648 15.9904 32.8273 16.0583C32.524 16.208 32.2988 16.5029 32.2442 16.8639L30.8455 25.9629L30.8054 26.2281C30.8973 25.6292 31.3956 25.1885 31.9867 25.1885H34.4476C39.2809 25.1885 43.0654 23.1721 44.1715 17.3396C44.2046 17.1669 44.2324 16.9989 44.2572 16.8345C43.9774 16.682 43.6743 16.5515 43.3479 16.4404C43.2673 16.4128 43.1841 16.3863 43.1002 16.3606Z",
    fill: "#22284F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2442 16.8633C32.2988 16.5024 32.524 16.2075 32.8274 16.0588C32.9659 15.9906 33.1187 15.9531 33.2807 15.9531H39.8551C40.6338 15.9531 41.3609 16.0056 42.0245 16.1157C42.2141 16.1468 42.3982 16.1828 42.578 16.2232C42.7569 16.2644 42.9312 16.3104 43.1003 16.3609C43.1842 16.3866 43.2673 16.4133 43.3488 16.4398C43.6751 16.551 43.9785 16.6825 44.2582 16.834C44.5874 14.6782 44.2555 13.2104 43.1208 11.8813C41.8697 10.4179 39.6118 9.79169 36.7226 9.79169H28.3345C27.7444 9.79169 27.2409 10.2324 27.1497 10.8324L23.656 33.5794C23.5872 34.0294 23.9251 34.4354 24.3669 34.4354H29.5453L32.2442 16.8633Z",
    fill: "#28356A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 46,
    rx: 3.5,
    stroke: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPalAccount);
export default __webpack_public_path__ + "static/media/pay_pal_account.04b3d2e25d8c8d76074b8be49e2bc9de.svg";
export { ForwardRef as ReactComponent };